import { render } from "./ObserverComponent.vue?vue&type=template&id=9fcd6996&ts=true"
import script from "./ObserverComponent.vue?vue&type=script&lang=ts"
export * from "./ObserverComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__